export default __webpack_public_path__ + "static/media/kitchen4-afterC-2048w.96262949.png";